export const LAUNCHDARKLY_CLIENT_ID = process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID || ''

export function isLaunchDarklyEnabled(): boolean {
  return !!LAUNCHDARKLY_CLIENT_ID
}
